module.exports = __webpack_public_path__ + "img/imagesalada.0cda9bb6.jpeg";